/**
 * The Resto Bonus numbers as PUBLISHED to diners and venues: the /bonus-rules
 * page, the landing's stamp card, the "too new" Dine In copy. The server never
 * reads this file. It enforces the single `bonus_rules` row (§33b), and this
 * object must equal that row: the RLS probe fails if they drift.
 *
 * Changing a number: docs/features/bonus.md → "Change a bonus number".
 * Values kept as launched (DEC3, Oct 21 2026; still under discussion).
 */
export const BONUS_PUBLISHED = {
  /** bonus_rules.stamps_required */
  stampsRequired: 10,
  /** bonus_rules.max_item_value_ron */
  maxItemRon: 15,
  /** bonus_rules.min_account_age_hours */
  minAccountAgeHours: 24,
  /** bonus_rules.max_redemptions_per_venue_day */
  maxPerVenueDay: 30,
  /** bonus_rules.pin_max_tries */
  pinMaxTries: 5,
  /** bonus_rules.pin_lock_minutes */
  pinLockMinutes: 15,
  /** bonus_rules.pin_max_fails_per_day */
  pinMaxFailsPerDay: 10,
} as const;

/** `{placeholders}` for the /bonus-rules text (LEGAL_B* keys). */
export const BONUS_RULES_VARS = {
  ...BONUS_PUBLISHED,
  stampsWhileHolding: BONUS_PUBLISHED.stampsRequired - 1,
};
